"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var searchIndex = function searchIndex(itemName, searchString) {
  return itemName.toLowerCase().indexOf(searchString.toLowerCase());
};

var filterItems = function filterItems(items, search) {
  return items.filter(function (item) {
    var itemName = _typeof(item) === 'object' ? item.farmname || item.name : item;
    var indexSearch = searchIndex(itemName, search);
    return indexSearch !== -1;
  });
};

var renderSuggestion = function renderSuggestion(item, search, onSearch, index) {
  var itemName = _typeof(item) === 'object' ? item.farmname || item.name : item;
  var indexSearch = searchIndex(itemName, search);

  if (indexSearch === -1) {
    return '';
  }

  var beforeSearch = itemName.slice(0, indexSearch);
  var matchedSearch = itemName.slice(indexSearch, indexSearch + search.length);
  var afterSearch = itemName.slice(indexSearch + search.length);
  return /*#__PURE__*/_react.default.createElement("li", {
    key: index,
    className: 'suggestion',
    onClick: function onClick() {
      return onSearch(itemName);
    }
  }, beforeSearch, /*#__PURE__*/_react.default.createElement("strong", null, matchedSearch), afterSearch);
};

var renderCategory = function renderCategory(category, filteredItems, search, onSearch, index, t) {
  if (filteredItems.length === 0) {
    return null;
  }

  var filteredResults = filteredItems.filter(function (item) {
    var itemName = _typeof(item) === 'object' ? item.farmname || item.name : item;
    var indexSearch = searchIndex(itemName, search);
    return indexSearch !== -1;
  });

  if (filteredResults.length === 0) {
    return '';
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: "list-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "suggest-title search-suggestion--".concat(category)
  }, t(category)), /*#__PURE__*/_react.default.createElement("ul", {
    key: index,
    className: "suggest-list list-".concat(category)
  }, filteredItems.map(function (item, itemIndex) {
    return renderSuggestion(item, search, onSearch, itemIndex);
  })));
};

var InputAutoSuggest = /*#__PURE__*/function (_Component) {
  _inherits(InputAutoSuggest, _Component);

  function InputAutoSuggest(props) {
    var _this;

    _classCallCheck(this, InputAutoSuggest);

    _this = _possibleConstructorReturn(this, (InputAutoSuggest.__proto__ || Object.getPrototypeOf(InputAutoSuggest)).call(this, props));
    _this.state = {
      search: props.search
    };
    return _this;
  }

  _createClass(InputAutoSuggest, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.hasSearched) {
        return '';
      }
    }
  }, {
    key: "updateDebouncedSearch",
    value: function updateDebouncedSearch(search) {
      this.setState({
        debouncedSearch: search
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          suggestions = _this$props.suggestions,
          innerRef = _this$props.innerRef,
          onSearch = _this$props.onSearch;
      var _this$props2 = this.props,
          search = _this$props2.search,
          t = _this$props2.t;

      if (!suggestions || Object.values(suggestions).every(function (category) {
        return category.length === 0;
      })) {
        return '';
      }

      var filteredSuggestions = Object.keys(suggestions).reduce(function (acc, category) {
        acc[category] = filterItems(suggestions[category], search);
        return acc;
      }, {});

      if (!filteredSuggestions || Object.values(filteredSuggestions).every(function (category) {
        return category.length === 0;
      }) || !search) {
        return '';
      }

      if (this.props.showSuggestions) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "input-auto-suggest",
          ref: innerRef
        }, Object.keys(suggestions).map(function (category, index) {
          var filteredItems = suggestions[category];
          return renderCategory(category, filteredItems, search, onSearch, index, t);
        }));
      }
    }
  }]);

  return InputAutoSuggest;
}(_react.Component);

InputAutoSuggest.propTypes = {
  suggestions: _propTypes.default.shape({
    farms: _propTypes.default.array,
    products: _propTypes.default.array,
    locations: _propTypes.default.array
  }),
  search: _propTypes.default.string,
  innerRef: _propTypes.default.object,
  onSearch: _propTypes.default.func,
  hasSearched: _propTypes.default.bool,
  showSuggestions: _propTypes.default.bool,
  t: _propTypes.default.func.isRequired
};
var _default = InputAutoSuggest;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search-field/lib/input-suggest.js
// module id = 880
// module chunks = 0